function initDefaultConfiguration() {
  const configurator = document.querySelector('.default-configuration');

  if (!configurator) return;

  let currentConfigData = null;
  let selectedOptions = {};

  function toggleAnnouncementBar(isDrawerOpen) {
    if (announcementBar) {
      announcementBar.style.display = isDrawerOpen ? 'none' : 'block';
    }
  }

  function showSpinner() {
    window.SpinnerUtils.showDefault(configurator);
  }

  function hideSpinner() {
    window.SpinnerUtils.hideDefault(configurator);
  }

  function showContent() {
    configurator.querySelector('.default-configuration__media.desktop').style.display = 'block';
    configurator.querySelector('.default-configuration__header').style.display = 'flex';
    configurator.querySelector('.default-configuration__media.mobile').style.display = 'block';
    configurator.querySelector('.default-configuration__info-container').style.display = 'block';
  }

  function hideContent() {
    configurator.querySelector('.default-configuration__media.desktop').style.display = 'none';
    configurator.querySelector('.default-configuration__header').style.display = 'none';
    configurator.querySelector('.default-configuration__media.mobile').style.display = 'none';
    configurator.querySelector('.default-configuration__info-container').style.display = 'none';
  }

  function populateConfiguration(customizationSteps) {
    const stepsContainer = configurator.querySelector('.default-configuration__steps');
    if (!stepsContainer || !customizationSteps) return;

    stepsContainer.innerHTML = '';

    customizationSteps.forEach((step, index) => {
      const stepElement = createStepElement(step, index);
      stepsContainer.appendChild(stepElement);
    });

    setupOptionSelection();
  }

  function createStepElement(step, index) {
    const stepDiv = document.createElement('div');
    stepDiv.className = `default-configuration__step step-${index}`;
    stepDiv.setAttribute('data-model-type', step.modelType);

    const stepTitle = document.createElement('h3');
    stepTitle.className = 'default-configuration__step-title';
    stepTitle.textContent = `${step.modelType.toUpperCase()}`;
    stepDiv.appendChild(stepTitle);

    step.attributes.forEach(attribute => {
      const attributeElement = createAttributeElement(attribute, step.modelTypeId);
      if (attributeElement) {
        stepDiv.appendChild(attributeElement);
      }
    });

    return stepDiv;
  }

  function createAttributeElement(attribute, modelTypeId) {
    let defaultOption = attribute.options.find(option => option.isSelected === true);

    if (!defaultOption && attribute.options.length > 0) {
      defaultOption = attribute.options[0];
    }

    if (!defaultOption || defaultOption.name === null) {
      return null;
    }

    const attributeDiv = document.createElement('div');
    attributeDiv.className = 'default-configuration__attribute';
    attributeDiv.setAttribute('data-attribute-id', attribute.attributeId);

    const attributeInfo = document.createElement('div');
    attributeInfo.className = 'default-configuration__attribute-info';

    attributeInfo.textContent = `${attribute.title}: ${defaultOption.name}`;
    selectedOptions[attribute.attributeId] = defaultOption.id;

    attributeDiv.appendChild(attributeInfo);
    return attributeDiv;
  }

  function setupOptionSelection() {
  }

  document.addEventListener('click', async function (event) {
    const openTrigger = event.target.closest('.default-configuration__open');
    const closeTrigger = event.target.closest('.default-configuration__close');

    if (openTrigger) {
      const sku = openTrigger.getAttribute('data-sku');

      if (sku) {
        configurator.classList.add('open');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        toggleAnnouncementBar(true);
        showSpinner();

        try {
          const result = await apiService.getProductConfigurator(sku);

          currentConfigData = result.data;

          if (result.data.customizationSteps) {
            result.data.customizationSteps.forEach(step => {
              step.attributes.forEach(attribute => {
                let defaultOption = attribute.options.find(option => option.isSelected === true);

                if (!defaultOption && attribute.options.length > 0) {
                  defaultOption = attribute.options[0];
                }

                if (defaultOption && defaultOption.name !== null) {
                  selectedOptions[attribute.attributeId] = defaultOption.id;
                }
              });
            });
          }

          populateConfiguration(result.data.customizationSteps);
          showContent();
          hideSpinner();

        } catch (error) {
          if (error instanceof ApiError) {
            console.error(`API Error getting product configurator:`, error);
          } else {
            console.error(`Network error getting product configurator:`, error);
          }
          hideSpinner();
        }
      }
    }

    if (closeTrigger) {
      configurator.classList.remove('open');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      toggleAnnouncementBar(false);
      hideContent();
      currentConfigData = null;
      selectedOptions = {};
    }
  });

  const resetBtn = configurator.querySelector('.default-configuration__btn--secondary');
  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      if (currentConfigData && currentConfigData.customizationSteps) {
        selectedOptions = {};
        populateConfiguration(currentConfigData.customizationSteps);
      }
    });
  }

  const applyBtn = configurator.querySelector('.default-configuration__btn--primary');
  if (applyBtn) {
    applyBtn.addEventListener('click', () => {
      configurator.classList.remove('open');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      toggleAnnouncementBar(false);
    });
  }
}

document.addEventListener('DOMContentLoaded', initDefaultConfiguration);